module.exports = __webpack_public_path__ + "static/organicrainbow3-00f0aa5c795a1f101e718ac4be7427ea.png";